import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { Links, LinksProps } from "../../components/Links";

export interface NearOurNetworkPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  faqs?: FaqAccordionGroupProps;
  chequeredBoard?: BasicChequeredBoardProps;
  paragraphs?: ParagraphProps[];
  linksList?: LinksProps[];
}

export const NearOurNetworkPage: React.FC<NearOurNetworkPageProps> = ({ seo, pageTitle, faqs, chequeredBoard, paragraphs, linksList }) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
